import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Order, OrderRequestTimeframe } from "@models/order";
import {
  OrderDetailsDialogComponent,
  OrderDetailsDialogData,
} from "@shared/modals/order-details-dialog/order-details-dialog.component";
import { PaginatorState } from "primeng/paginator";
import { BehaviorSubject, combineLatest, concat, of, switchMap } from "rxjs";
import { CartService } from "../../../services/cart.service";
import { OrderListComponent } from "../order-list/order-list.component";

@Component({
  selector: "app-order-list-container",
  imports: [OrderListComponent, CommonModule],
  templateUrl: "./order-list-container.component.html",
  styleUrl: "./order-list-container.component.scss",
})
export class OrderListContainerComponent {
  private readonly _cartService = inject(CartService);
  private readonly _dialog = inject(MatDialog);
  private readonly _router = inject(Router);
  private readonly _refreshOrders$ = new BehaviorSubject<void>(undefined);
  private readonly _currentPage$ = new BehaviorSubject<
    PaginatorState | undefined
  >(undefined);

  @Input() isMobile = false;
  @Input({ required: true }) listTimeframe!: OrderRequestTimeframe;

  orderList$ = combineLatest([this._refreshOrders$, this._currentPage$]).pipe(
    switchMap(([_, page]) =>
      concat(of(null), this._cartService.getMyOrders(this.listTimeframe, page)),
    ),
  );

  openOrderModal(order: Order): void {
    this._dialog.open(OrderDetailsDialogComponent, {
      width: "800px",
      maxWidth: "95vw",
      data: { order } as OrderDetailsDialogData,
    });
  }

  goToEvent(event_id: number) {
    this._router.navigate([`/event/${event_id}`]);
  }

  reloadTicketsAfterChange() {
    this._refreshOrders$.next();
  }

  handleLoadMoreClick(page: PaginatorState) {
    this._currentPage$.next(page);
  }

  handlePaymentClick(order: Order) {
    this._router.navigate([`/order-checkout/${order.id}`]);
  }
}
